<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">M.Com</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">M.Com</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="bba ptb--100  horizontal--tab">
  <div class="container">
    <div class="row">
      <div class="col">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="objectives-tab" data-bs-toggle="tab" data-bs-target="#objectives"
              type="button" role="tab" aria-controls="objectives" aria-selected="false">Objectives</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="duration-tab" data-bs-toggle="tab" data-bs-target="#duration" type="button"
              role="tab" aria-controls="duration" aria-selected="false">Duration</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="eligibility-tab" data-bs-toggle="tab" data-bs-target="#eligibility"
              type="button" role="tab" aria-controls="eligibility" aria-selected="false">Eligibility Criteria</button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="process-tab" data-bs-toggle="tab" data-bs-target="#process" type="button"
              role="tab" aria-controls="process" aria-selected="false">Admission Process</button>
          </li>
        </ul>
        <div class="tab-content px-3 py-3" id="myTabContent">
          <div class="tab-pane fade show active" id="objectives" role="tabpanel" aria-labelledby="objectives-tab">
            <ul class="list-before">
              <li>To equip and train Post Graduate students to accept the challenges
                of business world by providing opportunities for study and analysis of
                advanced commercial and business methods and processes.</li>
              <li>To develop independent logical thinking and facilitate personality
                development.</li>
              <li>To equip the students to seek suitable careers in management and
                entrepreneurship.</li>
              <li>To acquaint students with significance of research in business.</li>
              <li>To impart skills regarding methods of data collection and their
                interpretations.</li>
              <li>To develop communication and analytical skills among students.</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="duration" role="tabpanel" aria-labelledby="duration-tab">
            <h4 class="yellow-color fw-bold">3 years/6 semesters</h4>
            <ul class="list-before mt-3">
              <li>The M.Com. Course will be of Two Years duration consisting of two part. I.e. Part I and Part II. Each
                part is having Two Semesters. Thus, the M.Com. Course is of Four Semesters. For each Semester, there
                will be Four Papers of 100 marks each. M.Com. Degree will be of 1600 marks in aggregate.</li>
              <li><strong>Avenues to explore after BBA:</strong> - Is it a dream for you to make it big in the business
                industry? Do you want to learn the principles of management? Do you aspire to be proficient in the
                attributes of impeccable administration? Business management experts have an immensely vital role to
                play in every business. That first step towards this journey is a course in BBA. With the completion of
                the course immense is for you to look forward to.</li>
            </ul>
          </div>
          <div class="tab-pane fade" id="eligibility" role="tabpanel" aria-labelledby="eligibility-tab">
            <p>The student who has passed any Bachelors degree of this University or any other recognized University
              shall be held eligible to be admitted to M.Com. Course.</p>
          </div>
          <div class="tab-pane fade" id="process" role="tabpanel" aria-labelledby="process-tab">
            <p>An eligible student has to apply through the college application form for admission. Admissions will be
              offered to the students on their merit basis.</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
